import { useEffect, useRef } from "react";

const toPath = (polyline) =>
  (Array.isArray(polyline) ? polyline : [])
    .map((p) => ({ lat: Number(p?.lat), lng: Number(p?.lng ?? p?.long) }))
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));

const DriverRoute = ({ driver, map }) => {
  const linesRef = useRef(null);

  useEffect(() => {
    if (!map || !window.google?.maps) return undefined;
    const g = window.google.maps;

    const lines = {
      completed: new g.Polyline({ strokeColor: "#34A853", strokeWeight: 4, zIndex: 2 }),
      halo: new g.Polyline({ strokeColor: "rgba(0,149,255,0.35)", strokeWeight: 8, zIndex: 1 }),
      remaining: new g.Polyline({ strokeColor: "#0285FF", strokeWeight: 4, zIndex: 3 }),
    };
    linesRef.current = lines;

    return () => {
      Object.values(lines).forEach((line) => line.setMap(null));
      linesRef.current = null;
    };
  }, [map]);

  useEffect(() => {
    const lines = linesRef.current;
    if (!lines || !map) return;

    const hide = () => Object.values(lines).forEach((l) => l.setMap(null));

    const path = toPath(driver?.route?.polyline);
    if (path.length < 2) { hide(); return; }

    let index = Number(driver?.progress?.closestIndex);
    if (!Number.isFinite(index)) index = 0;
    index = Math.min(Math.max(Math.round(index), 0), path.length - 1);

    const completed = path.slice(0, index + 1);
    const remaining = path.slice(index);

    const apply = (line, points) => {
      if (points.length > 1) { line.setPath(points); line.setMap(map); }
      else line.setMap(null);
    };

    apply(lines.completed, completed);
    apply(lines.halo, remaining);
    apply(lines.remaining, remaining);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, driver?.routeSignature, driver?.progress?.closestIndex]);

  return null;
};

export default DriverRoute;